<header id="header-anahuac-onl">
  <div class="container">
    <div class="row">
      <div class="col-6 my-auto text-md-left text-center">
        <img src="/assets/img/sorteo2026/logo.png" alt="Sorteo Anáhuac 2025" class="img-fluid">
      </div>

      <!-- <div class="col-6 my-auto text-md-right text-center">
        <img src="/assets/img/sorteo2025/logo-online.png" alt="Sorteo Anáhuac Online 2025" class="img-fluid"
          width="280">
      </div> -->
    </div>
  </div>
</header>

<section class="stc-premios">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center p-0">


        <div class="custom-slider-container">
          <ngb-carousel #carousel1 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c1-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio1.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">EDO. MÉXICO</h1>
                    <h3 class="subtitle-place">Blue Bosque Real</h3>
                    <span class="price">Valor + de <strong>13.5 MILLONES</strong></span>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio2.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">CANCÚN</h1>
                    <h3 class="subtitle-place">Valor + de 13 MILLONES</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio3.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MÉRIDA</h1>
                    <h3 class="subtitle-place">Valor + de 6.6 MILLONES</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-3">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio4.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">PUEBLA</h1>
                    <h3 class="subtitle-place">Valor + de 6.2 MILLONES</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio5.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">QUERÉTARO</h1>
                    <h3 class="subtitle-place">Valor + de 5.4 MILLONES</h3>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel1.prev()" class="btn-nav"><i class="fa fa-chevron-left"></i></button>
            <button (click)="carousel1.next()" class="btn-nav"><i class="fa fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel1.select('c1-0')" [class.active]="carousel1.activeId === 'c1-0'">
              <img src="assets/img/sorteo2026/banner-premio1.jpg" alt="Edo México">
              <div class="thumb-info"><span class="rank">1°</span> <span class="name">EDO. MÉX.</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-1')" [class.active]="carousel1.activeId === 'c1-1'">
              <img src="assets/img/sorteo2026/banner-premio2.jpg">
              <div class="thumb-info"><span class="rank">2°</span> <span class="name">CANCÚN</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-2')" [class.active]="carousel1.activeId === 'c1-2'">
              <img src="assets/img/sorteo2026/banner-premio3.jpg">
              <div class="thumb-info"><span class="rank">3°</span> <span class="name">MÉRIDA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-3')" [class.active]="carousel1.activeId === 'c1-3'">
              <img src="assets/img/sorteo2026/banner-premio4.jpg">
              <div class="thumb-info"><span class="rank">4°</span> <span class="name">PUEBLA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-4')" [class.active]="carousel1.activeId === 'c1-4'">
              <img src="assets/img/sorteo2026/banner-premio5.jpg">
              <div class="thumb-info"><span class="rank">5°</span> <span class="name">QUERÉTARO</span></div>
            </div>
          </div>
        </div>


        <section id="lucky" class="aol">
          <div class="container-fluid">
            <div class="row">

              <div class="col-12 text-center">
                <div class="overlap-signature">
                  <h2 class="main-text">Máquina</h2>
                  <span class="letter ml-0 mt-0">de la suerte del egresado</span>
                </div>
              </div>

              <div class="col-xl-6 col-md-12 my-auto">

                <div class="width-100 text-center" [class.disabled-tab]="flag_buy_loader"
                  (click)="!flag_buy_loader && getBoletoRandom()">

                  <div class="activate-tab btn-effect-pro">
                    <span class="activate">ACTIVAR</span>
                  </div>
                </div>


                <div class="content-machine magno-machine text-center mx-auto">
                  <div class="text-center">
                    <img src="/assets/img/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac Magno" class="img-fluid mb-4"
                      width="260">
                  </div>

                  <div class="numbers-container">
                    <div class="numbers num-magno">
                      <ul id="list-n0">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>

                      </ul>
                    </div>
                    <div class="numbers num-magno">
                      <ul id="list-n1">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>


                      </ul>
                    </div>
                    <div class="numbers num-magno">
                      <ul id="list-n2">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>


                      </ul>
                    </div>

                    <div class="numbers num-magno">
                      <ul id="list-n3">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>


                      </ul>
                    </div>

                    <div class="numbers num-magno">
                      <ul id="list-n4">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>


                      </ul>
                    </div>

                    <div class="numbers num-magno">
                      <ul id="list-n5">
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <li>0</li>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>


                      </ul>
                    </div>

                  </div>


                  <div class="content text-center">

                    <a *ngIf="!flag_buy" (click)="getBoletoRandom();" class="btn-stack generate-number  mx-auto">

                      Activar
                    </a>
                    <div *ngIf="flag_buy_loader" class="w-100 text-center mt-3">
                      <p class="paragraph">
                        Generando tu número...
                      </p>
                      <!-- <div class="lds-hourglass"></div> -->
                      <img src="/assets/img/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">

                    </div>

                    <button *ngIf="flag_buy_btn" class="btn-stack btn-search mt-4" (click)="efectuarPago()"
                      [disabled]="botonDisabled">
                      Agregar a Carrito
                    </button>

                    <div id="Msg" [hidden]="true" class="alert alert-info mostrar text-center">
                      Por el momento no contamos con boletos disponibles
                    </div>
                    <!-- Mensaje de error: Cuando no está disponible el boletos consultado -->
                    <div *ngIf="boleto_disponible == 0" class="alert alert-info mostrar text-center">
                      El boleto ya no se encuentra disponible, favor de escoger otro
                    </div>



                  </div>


                </div>


              </div>

              <!-- <div class="col-xl-6 col-md-12  pt-xl-0 pt-4 text-center my-auto">
                <div class="content-head">
                  <p class="title">Descubre tu número mágico</p>
                  <h4>FECHA DEL SORTEO</h4>
                  <p style="margin: 10px 0 !important;"> 19 <span class="h-100 my-auto">.</span> nov <span>.</span> 2026
                  </p>

                

             
                  <div class="row">

                    <div class="col-md-12">

                      <span class="price mt-2  d-inline-block">
                        Boleto: $400

                      </span>
                    </div>


                  </div>

                </div>
              </div> -->

              <div class="col-xl-6 col-md-12  pt-xl-0 pt-4 text-center my-auto">
                <div class="content-head">

                  <p class="title">Descubre tu número mágico</p>
                  <!-- <p style="margin: 10px 0 !important;"> 10 <span class="h-100 my-auto">.</span> mayO <span>.</span> 2026
                  </p> -->
                  <h4>FECHA DEL SORTEO</h4>
                  <p style="margin: 10px 0 !important;"> 19 <span class="h-100 my-auto">.</span> nov <span>.</span> 2026
                  </p>

                  <p class="cost"> COSTO<strong> BOLETO </strong> </p>


                  <div class="row">

                    <div class="col-md-12">

                      <span class="price  d-inline-block"
                        style="font-size: 32px;  font-weight: 700;">
                        Boleto: $400

                      </span>
                    </div>


                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="stc-inputs">
          <div class="container">
            <div class="row container-input">
              <div class="col-md-12">
                <h3 class="text-center">
                  o selecciona tus boletos por:
                </h3>
              </div>

              <div class="col-md-12">
                <div class="row inside">
                  <!-- input 1 -->
                  <div class="col-md-4 offset-2">
                    <label for="busq-three" class="">
                      Boletos que inicien en:
                      <input type="radio" id="busq-three" name="options" (click)="inputDisabled(3)"
                        [checked]="!inputDisabled_3" />
                    </label>
                  </div>
                  <div class="col-md-4">
                    <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_3"
                      [disabled]="inputDisabled_3" />
                  </div>

                  <!-- input 2 -->
                  <div class="col-md-4 offset-2">
                    <label for="busq-one" class="">
                      Boletos que terminen en:
                      <input type="radio" id="busq-one" name="options" (click)="inputDisabled(1)"
                        [checked]="!inputDisabled_1" />

                    </label>
                  </div>

                  <div class="col-md-4">
                    <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_1"
                      [disabled]="inputDisabled_1" />
                  </div>

                  <!-- input 3 -->
                  <div class="col-md-4 offset-2">
                    <label for="busq-two" class="">
                      Boletos que contengan los dígitos:
                      <input type="radio" id="busq-two" name="options" (click)="inputDisabled(2)"
                        [checked]="!inputDisabled_2" />

                    </label>
                  </div>
                  <div class="col-md-4">
                    <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_2"
                      [disabled]="inputDisabled_2" />
                  </div>

                  <!-- input 4 -->

                  <div class="col-md-4 offset-2">
                    <label for="busq-four" class="">
                      ¿Buscas tu número de la suerte?
                      <span class="d-md-block">(teclea aquí)</span>
                      <input type="radio" id="busq-four" name="options" (click)="inputDisabled(4)"
                        [checked]="!inputDisabled_4" />

                    </label>
                  </div>
                  <div class="col-md-4">
                    <!-- Validar el minimo de caracteres -->
                    <input type="tel" class="input-box" placeholder=" _ _ _ _ _ _ " maxlength="6" [(ngModel)]="option_4"
                      [disabled]="inputDisabled_4" />
                  </div>



                </div>
              </div>

              <div class="col-12 col-md-6 text-center"
                *ngIf="option_1 ? true : option_2 ? true : option_3 ? true : option_4 ? true : false">
                <button class="btn-action btn-stack btn-search"
                  (click)="getLuckyBoleto(option_1, option_2, option_3, option_4)" data-toggle="modal"
                  data-target="#modalBoletos">
                  Buscar boleto <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </div>

              <div class="col-12 col-md-6 text-center">
                <button class=" btn-stack" (click)="efectuarPago()" [disabled]="botonDisabled">
                  Agregar a Carrito
                  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                </button>
              </div>

              <div class="col-12 col-md-6 text-center" *ngIf="boleto_.length > 0">
                <button id="item" class="btn-action btn-stack" (click)="efectuarPago()" visibility="hidden">
                  Pagar <i class="fa fa-money" aria-hidden="true"></i>
                </button>
              </div>




            </div>
          </div>
        </section>



        <br><br>

        <div class="custom-slider-container">
          <ngb-carousel #carousel2 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c2-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio6.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">AUDI</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio7.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MINI COOPER</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio8.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">KIA K3</h1>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel2.prev()" class="btn-nav"><i class="fa fa-chevron-left"></i></button>
            <button (click)="carousel2.next()" class="btn-nav"><i class="fa fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel2.select('c2-0')" [class.active]="carousel2.activeId === 'c2-0'">
              <img src="assets/img/sorteo2026/banner-premio6.jpg">
              <div class="thumb-info"><span class="rank">6°</span> <span class="name">AUDI</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-1')" [class.active]="carousel2.activeId === 'c2-1'">
              <img src="assets/img/sorteo2026/banner-premio7.jpg">
              <div class="thumb-info"><span class="rank">7°</span> <span class="name">MINI Cooper</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-2')" [class.active]="carousel2.activeId === 'c2-2'">
              <img src="assets/img/sorteo2026/banner-premio8.jpg">
              <div class="w-75 thumb-info d-flex flex-column text-center"><span class="rank">8°-12°</span> <span
                  class="name">KIA K3</span></div>
            </div>
          </div>
        </div>


        <div class="custom-slider-container mt-5">
          <ngb-carousel #carousel3 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c3-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio13-22.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MACBOOK AIR</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio23-32.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">IPHONE 17</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio33-42.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">IPAD AIR</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-3">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio43-56.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">AIRPODS MAX</h1>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/img/sorteo2026/banner-premio57-475.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">APPLE WATCH SE</h1>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel3.prev()" class="btn-nav"><i class="fa fa-chevron-left"></i></button>
            <button (click)="carousel3.next()" class="btn-nav"><i class="fa fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">

            <div class="thumb-card" (click)="carousel3.select('c3-0')" [class.active]="carousel3.activeId === 'c3-0'">
              <img src="assets/img/sorteo2026/banner-premio13-22.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">13°-22°</span> <span
                  class="name">MACBOOK AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-1')" [class.active]="carousel3.activeId === 'c3-1'">
              <img src="assets/img/sorteo2026/banner-premio23-32.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">23°-32°</span> <span
                  class="name">IPHONE 17</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-2')" [class.active]="carousel3.activeId === 'c3-2'">
              <img src="assets/img/sorteo2026/banner-premio33-42.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">33°-42°</span> <span
                  class="name">IPAD AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-3')" [class.active]="carousel3.activeId === 'c3-3'">
              <img src="assets/img/sorteo2026/banner-premio43-56.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">43°-56°</span> <span
                  class="name">AIRPODS MAX</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-4')" [class.active]="carousel3.activeId === 'c3-4'">
              <img src="assets/img/sorteo2026/banner-premio57-475.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">57°-475°</span> <span
                  class="name">WATCH SE</span></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>






<!-- Modal -->
<div class="modal fade" id="modalBoletos" tabindex="-1" role="dialog" aria-labelledby="modalBoletosCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Boletos generados</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <div class="row" id="ListBol" [hidden]="true">

          <div [class.mostrar]="Error === true" [class.ocultar]="Error === false"
            class="text-danger col-12 text-center">
            <h4>
              {{ mensajeError }}
            </h4>
          </div>

          <div [class.mostrar]="ErrorSuerte === true" [class.ocultar]="ErrorSuerte === false"
            class="text-danger col-12 text-center">
            <h4>
              En este Sorteo el boleto no está disponible
              ¿deseas que te lo reservemos para el próximo Sorteo?
            </h4>
            <button class="btn-action btn-stack d-block border-0 text-center mx-auto mt-4"
              (click)="Registrobol(option_4)">
              Reservar boleto
            </button>
          </div>



          <div *ngFor="let boleto of boletos" class="col-lg-3 col-md-4 col-6">
            <label class="" *ngIf="boleto.folio">
              <input name="boletos-seleccionados" type="checkbox" [(ngModel)]="boleto.marcado"
                value="{{ boleto.folio }}" (change)="btnable(boleto.marcado)" />

              {{ boleto.folio }}
              <span class="checkmark chec"></span>
            </label>
          </div>

        </div>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn-stack" data-dismiss="modal">
          Cerrar
        </button>
        <button class="btn-action btn-stack" (click)="efectuarPago()" [disabled]="botonDisabled"
          data-dismiss="modal">Agregar a Carrito</button>
      </div>
    </div>
  </div>
</div>
